module.exports = __webpack_public_path__ + "img/batch_id.3709331b.svg";